/**
 * @fileoverview Companion Ad View
 */
define('modules/partner/companion-ad',[
    'jquery',
    'underscore',
    'baseview',
    'adPosition'
],
function(
    $,
    _,
    BaseView,
    AdPosition
) {
    'use strict';
    /**
     * View class.
     */
    var CompanionAd = BaseView.extend({

        /**
         * @classdesc Companion Ad, a subclass of {@link BaseView}. A carousel companion ad
         * @constructs CompanionAd
         * @extends BaseView
         * @param {Object} options backbone options object
         *    @param {Object.<String, String>} [options.adPlacement] - placement in DFP (e.g. high_impact)
         *    @param {Object.<String, String>} [options.adSizes] - sizes the ad can render (e.g. mediumrectangle)
         *    @param {Function} [options.onViewable] - custom callback to run when ad has signaled it has fired a viewed impression
         *    @param {Function} [options.beforeAdRender] - custom callback to run when ad has signaled it is ready to render
         */
        initialize: function(options) {
            _.bindAll(this, 'posterViewable', 'posterTimeout');
            BaseView.prototype.initialize.call(this, options);

            this.options = options = $.extend({
                adPlacement: 'poster_gallery_companion',
                adSizes: ['mediumrectangle'],
                onViewable: this.posterViewable,
                beforeAdRender: this.posterTimeout,
                onEmpty: this.posterTimeout
            }, options);

            this.posterDefer = $.Deferred();
            this.subviews.ad = new AdPosition(options);
        },
        
        throttledRefresh: function() {
            if(this.posterDefer.state() === 'resolved') {
                this.posterDefer.then(_.bind(function() {
                    this.subviews.ad.refreshPosition();
                    this.posterDefer = $.Deferred();
                }, this));
            } else {
                // make sure we have a timeout set to resolve our defer
                this.posterTimeout();
            }
        },

        posterViewable: function() {
            this.posterDefer.resolve();
            clearTimeout(this.posterTO);
            delete this.posterTO;
        },

        posterTimeout: function() {
            // backup in case the google viewable event fails to fire
            if(!this.posterTO) {
                this.posterTO = setTimeout(_.bind(function() {
                    this.posterViewable();
                }, this), 4000);
            }
        }

    });

    /**
     * Return view class.
     */
    return CompanionAd;
});

